import { apiPostService } from './baseApi.service';

export default function logConversion(conversionIdentifier) {
  return (async () => {
    return apiPostService('/api/conversion/logconversion', conversionIdentifier);
  })();
}
